import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import services from '../../services/services';
import { setNewVersionAvailable } from '../../actions/actions';
import { isMobileSizeScreen } from '../../utils/utilsGlobal';
import styles from './VersionWatcher.scss';

const mapStateToProps = state => {
  return {
    newVersionAvailable: state.newVersionAvailable,
  };
};

const mapDispatchToProps = { setNewVersionAvailable };

@connect(mapStateToProps, mapDispatchToProps)
export class VersionWatcher extends Component {

  pollingInterval = null;
  pollingIntervalValue = 60 * 1000; // every minute

  componentDidMount(){
    this.checkVersion();
    this.pollingInterval = setInterval(this.checkVersion, this.pollingIntervalValue);
  }

  componentWillUnmount(){
    clearInterval(this.pollingInterval);
  }

  checkVersion = async () => {
    const { setNewVersionAvailable } = this.props;
    const currentVersion = process.env.ELIXIRCHAT_VERSION;
    const newVersion  = await this.fetchVersion();
    if (newVersion && newVersion !== currentVersion) {
      clearInterval(this.pollingInterval);
      setNewVersionAvailable(newVersion);
    }
  };

  onUpdateClick = () => {
    const { setNewVersionAvailable } = this.props;
    services.pwa.reset().finally(() => {
      setNewVersionAvailable(null);
      location.reload(true); // Force refresh
    });
  };

  fetchVersion = () => {
    try {
      return fetch('/version.json?' + Math.random())
        .then(response => response.json())
        .then(data => data.version);
    }
    catch (e) {
      return Promise.resolve(null);
    }
  };

  render(){
    const { className, setNewVersionAvailable, newVersionAvailable } = this.props;
    return (
      <div className={cn({
        [className]: true,
        [styles.container]: true,
        [styles.containerVisible]: newVersionAvailable,
      })}>
        {isMobileSizeScreen() ? 'Новая версия' : 'Доступна новая версия'}&nbsp;
        {newVersionAvailable}
        <button className={styles.update} onClick={this.onUpdateClick}>Обновить</button>
        <i className={cn(styles.close, 'icon-close-thin')} onClick={() => setNewVersionAvailable(null)}/>
      </div>
    );
  }
}
